import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Legend } from '../../../models/legend.models';
import { TranslocoDirective } from '@jsverse/transloco';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';

@Component({
  selector: 'ui-legend',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, TranslocoDecimalPipe],
  template: `
    @if (legend()) {
      <ng-container *transloco="let t">
        <div class="flex flex-col gap-y-3 w-full">
          <span>
            {{ t(legend().title) }}
          </span>
          <div class="flex flex-row justify-between gap-x-4 w-full">
            @for (item of legend().items; track item.name) {
              <div
                class="flex flex-col justify-center items-center border rounded-lg w-full"
                [class]="item.borderClass"
              >
                <div
                  class="px-6 py-2 rounded-t-lg w-full text-center"
                  [class]="[item.bgClass, item.textClass]"
                >
                  {{ t(item.name) }}
                </div>
                <div class="flex flex-row justify-between gap-x-1 w-full px-8">
                  @for (stat of item.stats; track stat.label) {
                    <div class="flex flex-col py-2 gap-y-1 text-center">
                      <span>{{ t(stat.label) }}</span>
                      <span class="whitespace-nowrap">
                        {{ stat.value != null ? (stat.value | translocoDecimal:{ minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: false  }) : '--' }}{{ stat.units }}
                      </span>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </ng-container>
    }
  `,
})
export class LegendComponent {
  /**
   * Signal that provides an array of phase data.
   * Each phase includes its name, styles, and statistics.
   */
  legend = input.required<Legend>();
}
